export default serviceClient => {
  return {
    backToList({rootState, commit, dispatch}, {reloadCategories = false}) {
      commit('setEditCategory', false);
      commit('setCategoryToEdit', undefined);
      commit('setCategoryToDelete', undefined);

      if (reloadCategories) {
        commit('setExternalContentUrlsModified', true, {root: true});
        dispatch('retrieveRowCategories', {
          page: rootState.rowCategoriesModule.currentPage - 1
        });
      }
    },
    async retrieveRowCategories({commit, rootState}, {page = 0}) {
      try {
        const result = await serviceClient.getRowCategories(
          rootState.accessToken,
          rootState.customer,
          {page}
        );
        commit('setRowCategories', result.content);
        commit('setPageCount', result.totalPages);
        commit('setCurrentPage', result.number + 1);
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async saveRowCategory({rootState, dispatch}, {name}) {
      try {
        const response = await serviceClient.saveRowCategory(
          rootState.accessToken,
          rootState.customer,
          {name}
        );
        return response;
      } catch (error) {
        dispatch('handleCategoryUpdateError', error);
      }
    },
    async updateRowCategory({rootState, dispatch}, {categoryId, category}) {
      try {
        await serviceClient.updateRowCategory(
          rootState.accessToken,
          rootState.customer,
          categoryId,
          category
        );
      } catch (error) {
        dispatch('handleCategoryUpdateError', error);
      }
    },
    async deleteRowCategory({rootState, commit}, {id}) {
      try {
        await serviceClient.deleteRowCategory(
          rootState.accessToken,
          rootState.customer,
          id
        );
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async handleCategoryUpdateError({commit}, error) {
      if (error.status !== 409) {
        commit('setError', error, {root: true});
        return;
      }
      commit(
        'setConflict',
        {
          status: true,
          kind: 'rowCategory',
          name: error.details[0].data
        },
        {root: true}
      );
    }
  };
};
